export enum OppgaveKanIkkeUtforesType {
  Default = 0,
  OppgaveTilpassetKunInnbygger = 1,
  OppgaveTilpassetIkkeFullmakt = 2,
  OppgaveTilpassetIkkePaVegnAvBarnUnder12 = 3,
  OppgaveTilpassetIkkePaVegnAvBarnMellom12Og16 = 4,
  OppgaveTilpassetIkkePaVegnAvBarn = 5,
  SperretAdresse = 6,
  Ungdom = 7,
}
